<template>
  <div class="contract-reminder">
    <!-- 标题区域 -->
    <div class="reminder-header">
      <h3 class="title">欠费信息</h3>
      <div class="index-number-describe margin-top-sm" @click="_toOwner">
        查看欠费信息
      </div>
    </div>

    <!-- 表头 -->
    <div class="table-header">
      <div class="table-cell tenant-name">楼栋号</div>
      <div class="table-cell room-number">欠费金额</div>
      <div class="table-cell room-number">费用类型</div>
    </div>

    <!-- 列表内容 -->
    <ul id="pool" class="contract-list">
      <!-- 无数据状态 -->
      <li v-if="!displayList || displayList.length === 0" class="no-data">
        {{暂无数据}}
      </li>

      <!-- 欠费列表项 -->
      <li
        v-else
        v-for="item in displayList"
        :key="item.payerObjId"
        class="contract-item"
      >
        <div class="table-cell tenant-name">{{ item.payerObjName }}</div>
        <div class="table-cell room-number">
          {{ formatAmount(item.amountOwed) }}元
        </div>
        <div class="table-cell room-number">{{ item.configName }}</div>
      </li>
    </ul>

    <!-- 查看全部按钮：仅当总数据量超过5条时显示 -->
    <div class="view-all-container" v-if="arrearsList.length > 5">
      <button class="view-all-btn" @click="_toOwner">查看全部欠费</button>
    </div>
  </div>
</template>

<script>
import { getOwnerRegisterIndex } from "@/api/index/propertyIndexApi";

export default {
  name: "IndexArrearsList",
  data() {
    return {
      arrearsList: [], // 存储所有欠费数据
    };
  },
  computed: {
    // 计算属性：只显示前5条数据
    displayList() {
      return this.arrearsList.slice(0, 5);
    },
    // 计算总欠费金额
    totalArrears() {
      return this.arrearsList.reduce((total, item) => {
        return total + Number(item.amountOwed || 0);
      }, 0);
    },
  },
  mounted() {
    this._loadArrearsData();
  },
  methods: {
    // 加载欠费数据
    async _loadArrearsData() {
      const param = {
        page: 1,
        row: 300,
        communityId: this.getCommunityId(),
        qfts: 0,
      };

      try {
        const res = await getOwnerRegisterIndex(param);
        if (res.code === 0) {
          this.arrearsList = res.data || [];
        } else {
          console.error("获取欠费数据失败:", res.msg);
        }
      } catch (error) {
        console.error("请求失败处理", error);
      }
    },
    _toOwner() {
      this.$router.push("/pages/property/listOweFee");
    },
    // 格式化金额显示
    formatAmount(amount) {
      if (!amount) return "0.00";
      const num = Number(amount);
      return isNaN(num) ? "0.00" : num.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
/* 样式保持不变 */
.index-number-describe {
  font-size: 12px;
  color: #999;
}
.margin-top-sm {
  margin-top: 5px;
}
.index-number-describe {
  font-size: 12px;
  color: #1890ff;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}
.contract-reminder {
  background: #fff;
  border-radius: 4px;
  padding: 23px;
  height: 100%;
  box-sizing: border-box;

  .reminder-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f0f0f0;

    .title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }
  }

  .table-header {
    display: flex;
    background-color: #f5f7fa;
    border-radius: 4px 4px 0 0;
    font-weight: 500;

    .table-cell {
      padding: 12px 10px;
      font-size: 13px;
      color: #666;
      text-align: left;
    }

    .tenant-name {
      width: 40%;
    }

    .room-number {
      width: 30%;
    }
  }

  .contract-list {
    height: 240px;
    overflow-y: auto;
    padding: 0;
    margin: 0;
    list-style: none;
    border: 1px solid #f0f0f0;
    border-top: none;
    border-radius: 0 0 4px 4px;

    .no-data {
      color: #999;
      text-align: center;
      padding: 40px 0;
      font-size: 14px;
    }

    .contract-item {
      display: flex;
      align-items: center;
      height: 45px;
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }

      .table-cell {
        padding: 0 10px;
        font-size: 13px;
        color: #333;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .tenant-name {
        width: 40%;
      }

      .room-number {
        width: 30%;
      }
    }
  }

  .view-all-container {
    display: flex;
    justify-content: center;
    margin-top: 15px;

    .view-all-btn {
      padding: 6px 20px;
      background-color: #f5f7fa;
      color: #666;
      border: none;
      border-radius: 4px;
      font-size: 14px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        background-color: #e9ecef;
        color: #333;
      }
    }
  }
}
</style>
